<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="3" y="3" width="7" height="7" rx="1.5" :fill="stroke" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" :fill="stroke" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" :fill="stroke" />
    <rect
      x="14"
      y="14"
      width="7"
      height="7"
      rx="1.5"
      :fill="stroke"
    />
  </svg>
</template>

<script>
export default {
  name: "FleetIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
